import { useEffect, useState } from "react";
import { useContext } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import Loader from "../Loader/Loader.jsx";
import "./CitationModal.css";
import { AppContext } from "../../utils/Context/AppContext.js";
import CROSS_ICON from "../../assets/close_icon.svg";
import ZOOM_IN from "../../assets/zoomInIcon.svg";
import ZOOM_OUT from "../../assets/zoomOutIcon.svg";
import DOWNLOAD from "../../assets/downloadIcon.svg";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const CitationModal = ({ isOpen, onClose }) => {
  const [modalOpen, setModalOpen] = useState(true);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const { appData, dispatch } = useContext(AppContext);
  const [scale, setScale] = useState(0.8);

  const closeModal = () => {
    handleResize();
    dispatch({
      type: "MODAL_TOGGLE",
      payload: false,
    });
  };

  const handlePageChange = (newPageNumber) => {
    setPageNumber(newPageNumber);
  };

  const handleDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const handleZoomIn = () => {
    setScale((prevScale) => Math.min(1.5, prevScale + 0.1)); // Limit max scale to 2.0
  };

  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(0.5, prevScale - 0.1)); // Limit min scale to 0.1
  };

const handleDownloadCitation = () => {
  window.open(appData?.activeCitation?.url, "_blank");
};

  function handleResize() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      setScale(0.6);
    } else if (screenWidth >= 1440) {
      setScale(1.21);
    } else {
      setScale(1.03);
    }
  }
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className={`fixed inset-0 z-50 overflow-auto transition-opacity ${
        appData.modalOpen
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex items-center justify-center">
        <div className="modal-container pb-12 sm:pb-0">
          <div className="relative modal-content rounded-[8px] overflow-hidden h-[500px] 2xl:h-[760px] w-[90%] md:w-[50%] 2xl:w-[39%] m-auto">
            <div className="modal-header flex items-center justify-between bg-[#00AEEF] p-2">
              <div className="flex items-center gap-3">
                <h1 className="text-[17x] text-[#fff] font-[900] ps-2">
                  {appData?.activeCitation?.citationDataType === "audio"
                    ? `Source-${appData?.activeCitation?.i + 1}`
                    : appData?.activeCitation?.citationName}
                </h1>
              </div>
              <img
                className="cursor-pointer"
                src={CROSS_ICON}
                alt=""
                onClick={closeModal}
              />
            </div>
            <div
              id="modal-body"
              className="relative modal-body h-[calc(100%_-_44px)]"
            >
              <Document
                className="h-full w-full"
                loading={<Loader className=" mt-[15.2rem] sm:mt-[33%]" />}
                file={
                  appData?.activeCitation?.url
                    ? appData?.activeCitation?.url
                    : null
                }
                onLoadSuccess={handleDocumentLoadSuccess}
              >
                {Array.from(new Array(numPages), (_, index) => (
                  <Page
                    loading={index === 0 ? <Loader /> : ""}
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    onPageChange={handlePageChange}
                    scale={scale}
                  />
                ))}
              </Document>
            </div>
            <div className="gap-2 flex rounded-sm bg-[#00AEEF] p-2 absolute bottom-4 left-1/2 transform translate-x-[-50%]">
              <button className="p-1/2 px-2" onClick={handleZoomIn}>
                <img className="h-4" src={ZOOM_IN} alt="" />
              </button>
              <button className="p-1/2 px-2" onClick={handleZoomOut}>
                <img className="h-4" src={ZOOM_OUT} alt="" />
              </button>
              {appData?.activeCitation?.citationDataType !== "audio" && (
                <button className="p-1/2 px-2" onClick={handleDownloadCitation}>
                  <img className="h-4" src={DOWNLOAD} alt="" />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CitationModal;
